import moment from 'moment';

const defaults = {
  default: "%m/%d/%Y",
  default_datepicker: "m/d/yyyy",
  default_date_fns: "d/M/yyyy",
  default_human: "mm/dd/yyyy",
  default_moment: "M/d/YYYY"
};

function getFormats() {
  const {
    I18n: {
      date: { formats } = {}
    } = {}
  } = global;

  return formats || defaults;
}

/**
 * DEPRECATED - use i18n.js - formatDateTime instead
 *
 * @deprecated does not handle time zone conversion
 *
 * @param str
 * @returns {string}
 */
function formattedDate(str) {
  const { default_moment } = getFormats();

  return moment(str).format(default_moment);
}

export {
  formattedDate,
  getFormats,
  formattedDate as default
};
